export const defaultAddedQuestionsValues: Record<string, any> = {
  instructorAddedQuestions: {
    questionCount: null,
    isCustomQuestionAllowed: false
  },
  academicLevelAddedQuestions: {
    academicUnitCategories: [],
    questionCount: null,
    isCustomQuestionAllowed: false
  },
  // CR-295 — one shared set per course section. Same defaults as instructorAddedQuestions;
  // the two blocks are deliberately identical apart from scope.
  sectionAddedQuestions: {
    questionCount: null,
    isCustomQuestionAllowed: false
  }
}
